import { Errors } from 'gleblu-socket-api';
import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import AccountActivationResult from '../../models/interfaces/AccountActivationResult';
import PlaceUser from '../../models/interfaces/PlaceUser';
import * as activateAccount from '../actions/registration/activateAccount';
import { employeeInvitationFetched } from '../actions/registration/fetchEmployeeInvitation';
import { employeeRegistrationCompleted } from '../actions/registration/registerEmployee';

export interface RegistrationState {
  readonly accountActivationResults: Map<string, { accountActivationResult: AccountActivationResult }>;
  readonly employeeInvitations: Map<string, { placeUser?: PlaceUser; errorType?: Errors }>;
}

const defaultState: RegistrationState = {
  accountActivationResults: Map<string, { accountActivationResult: AccountActivationResult }>(),
  employeeInvitations: Map(),
};

const registrationReducer = createReducer<RegistrationState>({}, defaultState);

registrationReducer.on(activateAccount.accountActivationFinished, (state, { token, accountActivationResult }) => {
  const { accountActivationResults, ...others } = state;
  return { ...others, accountActivationResults: accountActivationResults.set(token, { accountActivationResult }) };
});
registrationReducer.on(activateAccount.accountActivationFailed, (state, { token, accountActivationResult }) => {
  const { accountActivationResults, ...others } = state;
  return { ...others, accountActivationResults: { ...accountActivationResults, [token]: { accountActivationResult } } };
});

registrationReducer.on(employeeInvitationFetched, (state, { token, placeUser, errorType }): RegistrationState => {
  const { employeeInvitations, ...others } = state;
  return {
    ...others,
    employeeInvitations: employeeInvitations.set(token, { placeUser, errorType }),
  };
});

registrationReducer.on(employeeInvitationFetched, (state, { token, placeUser, errorType }): RegistrationState => {
  const { employeeInvitations, ...others } = state;
  return {
    ...others,
    employeeInvitations: employeeInvitations.set(token, { placeUser, errorType }),
  };
});

registrationReducer.on(employeeRegistrationCompleted, (state, { token, placeUser }): RegistrationState => {
  const { employeeInvitations, ...others } = state;
  return {
    ...others,
    employeeInvitations: employeeInvitations.set(token, { ...employeeInvitations.get(token), placeUser }),
  };
});

export default registrationReducer;
